<script>
	import { Row, Col } from "@sveltestrap/sveltestrap";
	import { afterUpdate, onMount } from "svelte";
	import { field } from "svelte-forms";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import RulesTable from "./RulesTable.svelte";
	import { navigate } from "svelte-routing";
	import CustomSelect from "../../../components/CustomSelect/CustomSelect.svelte";
	import { masterData, loading, totalPages } from "src/store/store";
	import { extractErrorMessage } from "src/utils/misc";
	import client from "src/services/client";
	import queryString from "query-string";
	import ErrorBanner from "../../../components/ErrorBanner/ErrorBanner.svelte";

	let err;
	let missingRules = [];

	let data = {
		totalCount: 0,
		totalPage: 0,
		pageNumber: 1,
		pageSize: 20,
		data: [],
		snapshotUpdatedAt: "",
	};

	let params = {
		page: 1,
		size: 20,
	};

	let sort = {
		sortCol: "",
		sortDir: "",
	};

	function handleSort(sortCol, sortDir) {
		sort = {
			sortCol,
			sortDir,
		};
		fetchFleetPartnerData($searchFleetPartner.value, sort);
	}

	let query = queryString.parse(window.location.search);

	const searchFleetPartner = field("searchFleetPartner", "");

	async function fetchMissingRules() {
		try {
			loading.set(true);
			const res = await client("/v1/servicing/rules/missing", {
				version: "Tasking",
			});
			if (res.status === 200) {
				missingRules = res.data;
			}
			loading.set(false);
		} catch (error) {
			extractErrorMessage(error);
			console.log(error);
			loading.set(false);
		}
	}

	async function fetchFleetPartnerData(id, sort) {
		try {
			params = {
				...params,
				...query,
			};
			if (id) {
				params = {
					...params,
					carAssetOwnerId: id,
				};
			} else {
				delete params.carAssetOwnerId;
			}
			if (sort?.sortCol) {
				params = {
					...params,
					...sort,
				};
			}
			loading.set(true);
			const res = await client("/v1/Servicing/rules", {
				version: "Tasking",
				params,
			});
			if (res.status === 200) {
				data = res.data;
				totalPages.set(data.totalPage);
				loading.set(false);
			}
		} catch (error) {
			extractErrorMessage(error);
			console.log(error);
			loading.set(false);
		}
	}

	function handleSearchDebounce() {
		fetchFleetPartnerData($searchFleetPartner.value);
	}

	onMount(() => {
		if (!query.page) {
			query.page = 1;
		}
		fetchFleetPartnerData();
		fetchMissingRules();
	});

	afterUpdate(() => {
		if (params.page != parseInt(query.page)) {
			params.page = parseInt(query.page);
			fetchFleetPartnerData($searchFleetPartner.value);
		}
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Row class="mb-3">
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Manage Rules" />
				</Col>
				<Col class="d-flex flex-row-reverse">
					<div class="ms-2">
						<CustomButton
							buttonText="Add rule"
							color="primary"
							on:click={() =>
								navigate("/servicing/manage-rules/add-rule")}
						/>
					</div>
				</Col>
			</Row>
			<Row class="d-flex mb-3">
				<Col xs={5} class="d-flex">
					<CustomSelect
						options={$masterData.carAssetOwners}
						label="Search"
						type="text"
						bind:value={$searchFleetPartner.value}
						search
						onChange={handleSearchDebounce}
						defaultOption={"Select fleet partner"}
					/>
				</Col>
			</Row>
			{#if missingRules && missingRules.length > 0}
				<ErrorBanner errorHeader="Warning">
					<ul>
						{#each missingRules as { carAssetOwnerName, fuelTypeName, carAssetOwnerId, fuelTypeId }}
							<li>
								<span>
									Servicing criteria is not available for {carAssetOwnerName}.
									{fuelTypeName}
								</span>
								<button
									type="button"
									class="link link-text"
									style="background:none;border:none;padding:0;cursor:pointer;font:inherit;"
									on:click={() =>
										navigate(
											"/servicing/manage-rules/add-rule",
											{
												state: {
													carAssetOwnerId:
														carAssetOwnerId,
													fuelTypeId: fuelTypeId,
												},
											}
										)}
								>
									Add a new rule.
								</button>
							</li>
						{/each}
					</ul>
				</ErrorBanner>
			{/if}
		</div>
	</Col>
	<Col>
		<RulesTable {data} {fetchFleetPartnerData} {handleSort} />
	</Col>
</Row>
